MOVE.LANDERS_FORECLOSURE = (function (MOVE) {
  var init = function () {
  };

  MOVE.LANDERS_FORECLOSURE =
  {
    init: init
  };

  return MOVE.LANDERS_FORECLOSURE;
})(MOVE || {});



// WEBPACK FOOTER //
// ./landers_foreclosure/landers_foreclosure.js